import type { FontConfig } from "@/domains/design/types"
import type { DeepPartial } from "@/domains/library"
import type { ResponsiveMode } from "@/hooks/use-responsive"
import { useFontConfig } from "@/domains/design/hooks/use-font-config"
import { HEADING_2_CONFIG } from "@/domains/design/system/heading-2"
import { cn } from "@/domains/library"

export const Heading2 = ({
  children,
  className,
  options,
  mode,
}: {
  children?: React.ReactNode
  className?: string
  options?: DeepPartial<FontConfig>
  mode?: ResponsiveMode
}) => {
  const config = useFontConfig({ baseConfig: HEADING_2_CONFIG, options, mode })

  if (!config) {
    return null
  }

  return (
    <h2
      className={cn(config.family.tw, config.weight.tw, config.size.tw, config.lineHeight.tw, "text-t100", className)}
    >
      {children}
    </h2>
  )
}
